import * as React from "react";
import { styled } from "@mui/material/styles";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { Typography, Divider } from "@mui/material";
import Tutorialumlang from "../Tutorialumlang";
import FrequentlyAskedPackages from "./FrequentlyAskedMainPage";
import ShortCutsList from "../KeysModal/ShortCutsList";
const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowBackIosIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(-90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export default function AccordianContents({
  handleOpenSelectVideoBox,
  handleFullScreen,
  handlePlayingStatus,
}) {
  const [expanded, setExpanded] = React.useState("");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <div>
      <Divider>آموزش ها</Divider>
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Typography>کلید های میانبر (ShortCut) برنامه</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <ShortCutsList/>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Typography>آموزش های ویدئویی کار با برنامه</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: "#687791" }}>
          <Tutorialumlang
            handleOpenSelectVideoBox={handleOpenSelectVideoBox}
            handleFullScreen={handleFullScreen}
            handlePlayingStatus={handlePlayingStatus}
          />
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
          <Typography>سوالات متداول</Typography>
        </AccordionSummary>

        <AccordionDetails sx={{ backgroundColor: "#687791" }}>
          <FrequentlyAskedPackages />
        </AccordionDetails>
      </Accordion>
      {/* <Accordion
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
          <Typography>آموزش های متنی کار با برنامه</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: "#687791" }}>
          <Typography>
            بله <span style={{ color: "red" }}>می توانید</span> همزمان از هر دو
            تخفیف استفاده کنید . هر دو تخفیف بر روی محصول انتخابی اعمال می گردد.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel4"}
        onChange={handleChange("panel4")}
      >
        <AccordionSummary aria-controls="panel4d-content" id="panel4d-header">
          <Typography>
            امکانات جدید و تغییر قیمت پکیج ها برای کاربرانی که قبلا خرید داشته
            اند چگونه است؟
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            هر گونه امکانات جدیدی که به پکیج اضافه شود برای کاربرانی که از قبل
            خرید داشته اند تا اتمام اعتبار پکیج آنها بصورت{" "}
            <span style={{ color: "red" }}>رایگان</span> در دسترس خواهد بود.
            <br />
            قابل ذکر است که بصورت مداوم امکانات و ویژگی های جدید به برنامه اضافه
            خواهد شد و در ابتدای عرضه برنامه (نسخه Beta) حداقل قیمتها در نظر
            گرفته شده است که پس از اضافه شدن ویژگی های جدید این تغییرات بر روی
            قیمت پکیج ها اثر گذار می باشد اما این تغییرات قیمت فقط برای کاربرانی
            که پس از اضافه شدن ویژگی جدید اقدام به خرید می کنند اعمال می شود.
          </Typography>
        </AccordionDetails>
      </Accordion> */}
    </div>
  );
}
